// Planner Display fields (the "Display" toolbar toggles).
//
// Single source of truth mapping the two key vocabularies in play:
//   - `key`        the card renderers gate on (PLANNER_DISPLAY_*), and the shape held in
//                  `settings.displayOptions` at runtime.
//   - `title`      shown in the Display popover row.
//   - `backendKey` the snake_case name stored in a saved view's `custom_filter`, as the
//                  comma-joined `display` value.
//
// Labels are intentionally NOT here: Labels are always shown and are no longer a toggle.
// "Colour by" lives in a sibling `colour_by` key on the same view, not in `display`.
export const PLANNER_DISPLAY_FIELDS = [
  {
    key: "PLANNER_DISPLAY_ORDER_NUMBER",
    title: "Order number",
    backendKey: "order_number",
  },
  {
    key: "PLANNER_DISPLAY_START_FINISH_TIME",
    title: "Start & finish time",
    backendKey: "start_finish_time",
  },
  {
    key: "PLANNER_DISPLAY_CUSTOMER_NAME",
    title: "Customer name",
    backendKey: "customer_name",
  },
  {
    key: "PLANNER_DISPLAY_PO_NUMBER",
    title: "PO number",
    backendKey: "po_number",
  },
  {
    key: "PLANNER_DISPLAY_NOTES",
    title: "Notes",
    backendKey: "notes",
  },
  {
    key: "PLANNER_DISPLAY_ASSIGNEES",
    title: "Assignees",
    backendKey: "assignees",
  },
];

// The default is every field on, per F01-3. A saved view stores its `display` as a comma-joined
// list of these backendKey strings.
export const ALL_DISPLAY_BACKEND_KEYS = PLANNER_DISPLAY_FIELDS.map((field) => field.backendKey);
